import React, { useEffect, useMemo, useState } from 'react';
import ThumbnailName from '../ThumbnailName';
import BasicInfo from '../BasicInfo';
import CurrentEvents from '../CurrentEvents';
import MakeEvents from '../MakeEvents';
import FollowRivalList from '../FollowRivalList';
import useApiControl from '../../../common/useApiControl';

function OtherUser({ user, makeEvents }) {
  const [joinEvents, setJoinEvents] = useState([]);
  const [visibleSection, setVisibleSection] = useState('makeEvents');

  // マスタータグ取得
  const { data: masterTagsData, executeRequest: fetchMasterTags } = useApiControl({
    action: '/get_master_tags',
    method: 'POST',
  });

  const joinEventsParams = useMemo(() => {
    if (user?.id) {
      return {
        userIds: [user.id],
        includesDeleted: true,
        uncheckedCheckoutOnly: true,
      };
    }
    return null;
  }, [user?.id]);

  const { data: joinEventsData, executeRequest: fetchJoinEvents } = useApiControl({
    action: '/get_join_events',
    params: joinEventsParams,
    method: 'POST',
  });

  useEffect(() => {
    fetchMasterTags();
  }, []);

  useEffect(() => {
    setVisibleSection('makeEvents');
  }, [user?.id]);

  useEffect(() => {
    if (!joinEventsParams) {
      setJoinEvents([]);
      return;
    }

    fetchJoinEvents().catch((error) => {
      console.error('Failed to fetch join events:', error);
    });
  }, [joinEventsParams]);

  useEffect(() => {
    setJoinEvents(joinEventsData?.events || []);
  }, [joinEventsData]);

  const handleClickDetail = (label) => {
    const sectionByLabel = {
      ルーム作成数: 'makeEvents',
      ルーム参加数: 'events',
      フォロー数: 'follow',
      ライバル数: 'rival',
    };

    const targetSection = sectionByLabel[label];
    if (!targetSection) {
      return;
    }

    setVisibleSection((prev) => (prev === targetSection ? null : targetSection));
  };

  return (
    <div style={{ backgroundColor: '#eef6ff', minHeight: 'calc(100vh - 64px)' }}>
      {/* 1. サムネイル＋名前 */}
      <ThumbnailName user={user} isSelf={false} />

      {/* 2. 基本情報 */}
      <BasicInfo
        user={user}
        makeEvents={makeEvents}
        joinedCount={joinEvents.length}
        visibleSection={visibleSection}
        onClickDetail={handleClickDetail}
      />

      {/* 3. 詳細情報（参加中イベント/フォロー/ライバル） */}
      {visibleSection === 'makeEvents' && (
        <MakeEvents makeEvents={makeEvents} masterTagsData={masterTagsData} />
      )}
      {visibleSection === 'events' && (
        <CurrentEvents joinEvents={joinEvents} masterTagsData={masterTagsData} />
      )}
      {visibleSection === 'follow' && (
        <FollowRivalList user={user} listType="follow" />
      )}
      {visibleSection === 'rival' && (
        <FollowRivalList user={user} listType="rival" />
      )}
    </div>
  );
}

export default OtherUser;
